export default {
  title: 'Virksomhedens reservationstjeneste er deaktiveret',
  description:
    'Reservationstjenesten er i øjeblikket inaktiv for denne virksomhed. Du kan aktivere den under Tjenester.',
  button: {
    settings: 'Gå til indstillinger',
  },
};
